module.exports = __webpack_public_path__ + "static/media/6.13552c33.png";